import {incomePlanAxios} from "@/axios";
export default {
    namespaced: true,

    state: {
        integrated: false,
        username: null,
        lastUpdated: null
    },

    actions: {
        fetchIntegrationInformation({commit}, {householdId}) {
            return incomePlanAxios
                .get(`api/households/${householdId}/aqumulate/info`)
                .then((response) => {
                    let integrationInfo = response.data.data.integration;

                    if (integrationInfo) {
                        commit('SET_INTEGRATED', {integrated: true, data: integrationInfo})
                        return response;
                    }

                    commit('SET_INTEGRATED', {integrated: false, data: {}})
                })
        },

        connect({dispatch}, {credential, householdId}) {
            return incomePlanAxios
                .post(`api/households/${householdId}/aqumulate/connect`, credential)
                .then(() => {
                    return dispatch('aqumulate/fetchIntegrationInformation', {householdId}, {root: true})
                });
        },

        disconnect({commit}, householdId) {
            return incomePlanAxios
                .post(`api/households/${householdId}/aqumulate/disconnect`)
                .then(() => {
                    commit('SET_INTEGRATED', {integrated: false, data: {}})
                });
        },

        pullAccountsData({commit}, householdId) {
            return incomePlanAxios
                .post(`api/households/${householdId}/aqumulate/pull-accounts-data`)
                .then((r) => {
                    let lastUpdated = r.data.data.lastUpdated
                    commit('SET_LAST_UPDATED', lastUpdated)
                });
        }
    },

    mutations: {
        ['SET_INTEGRATED'] (state, {integrated, data}) {
            state.integrated = integrated;
            state.username = data.username;
            state.lastUpdated = data.lastUpdated;
        },
        ['SET_LAST_UPDATED'] (state, lastUpdated) {
            state.lastUpdated = lastUpdated;
        },
    }
}
